import React, { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { MinusIcon, PlusIcon } from "../../../constant/icon";
import { DataContext } from "../../../contexts/DataContext";
import { useLanguage } from "../../../hooks/useLanguage";
import BaseButton from "../../button/BaseButton";
import BaseSelectV2 from "../../select/BaseSelectV2";
import { generateNameOption } from "../../../utils/generateOptionSelect";

export default function AddTicketRow({ ticketTypes = [] }) {
  const { nameWithLanguage, currentLanguage } = useLanguage();
  const [ticketTypeSelect, setTicketTypeSelect] = useState(null);
  const [quantityTicket, setQuantityTicket] = useState(0);

  const { t } = useTranslation();

  const { onSetTicketUserBuy, ticketUserBuy } = useContext(DataContext);

  const listIdTicketUserBuy = ticketUserBuy.map((item) => {
    return item?.id;
  });

  const ticketTypesSelectAvailable = ticketTypes.filter((item) => {
    if (!listIdTicketUserBuy.includes(item.id)) {
      return item;
    }
  });

  const onIncCease = useCallback(() => {
    setQuantityTicket(quantityTicket + 1);
  }, [quantityTicket]);
  const onDeCrease = useCallback(() => {
    if (quantityTicket <= 1) return;
    setQuantityTicket(quantityTicket - 1);
  }, [quantityTicket]);

  const onSelectTicket = useCallback((e) => {
    if (e?.numberCanBuy <= 0) {
      return;
    }
    setQuantityTicket(e?.numberCanBuy >= 1 ? 1 : 0);

    setTicketTypeSelect(e);
  }, []);

  const handleAddTicket = useCallback(() => {
    const ticketWithQuantity = {
      ...ticketTypeSelect,
      quantity: quantityTicket,
    };
    onSetTicketUserBuy(ticketWithQuantity);
    setTicketTypeSelect(null);
    setQuantityTicket(0);
  }, [ticketTypeSelect, quantityTicket, onSetTicketUserBuy]);

  const disableButtonIncCease =
    !ticketTypeSelect ||
    ticketTypeSelect?.remainingQuantity <= 0 ||
    quantityTicket >= ticketTypeSelect?.limitForUser ||
    quantityTicket >= ticketTypeSelect?.numberCanBuy;

  const listTicketTicket = [];

  ticketTypesSelectAvailable.map((itemTicket) => {
    listTicketTicket.push(itemTicket);
  });
  return (
    <div className="grid w-full grid-rows-3 md:grid-rows-none md:grid-cols-12 gap-x-3 gap-y-4 lg:gap-y-3 md:gap-y-0">
      <div className="flex items-center col-span-4 md:grid lg:col-span-5">
        <BaseSelectV2
          size="sm"
          className={"h-9 px-3 py-2 border-neutral-300"}
          options={ticketTypesSelectAvailable} //convert data to array object with {name: "zxc", ...item}
          dataTitle={(e) =>
            e ? generateNameOption(e, t, nameWithLanguage) : ""
          }
          placeHolder={t("select_ticket")}
          onChange={onSelectTicket}
          value={ticketTypeSelect ? ticketTypeSelect[nameWithLanguage] : ""}
        />
      </div>
      <div className="flex items-center col-span-4 md:col-span-3 md:grid ">
        <div className="flex flex-row items-center justify-end w-full md:justify-center ">
          <div className="flex flex-row items-center gap-x-3 md:gap-x-6">
            <div>
              <BaseButton
                disable={!ticketTypeSelect || quantityTicket <= 1}
                onClick={onDeCrease}
                className="rounded-lg"
                sizeButton="small"
                variant="outline"
              >
                <MinusIcon />
              </BaseButton>
            </div>
            <p className="font-medium md:font-bold text-neutral-600 md:text-body-1 text-body-2">
              {quantityTicket}
            </p>
            <div>
              <BaseButton
                disable={disableButtonIncCease}
                onClick={onIncCease}
                className="rounded-lg"
                sizeButton="small"
                variant="outline"
              >
                <PlusIcon />
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center w-full col-span-4 lg:col-span-3">
        <div className="flex flex-row-reverse items-center justify-between w-full md:flex-row gap-x-4 ">
          <p className="font-bold text-purple-600 md:text-neutral-800 md:text-body-1 text-title-2">
            {/* SR {ticketTypeSelect?.price * quantityTicket || 0} */}
            {currentLanguage === "en"
              ? `${ticketTypeSelect?.price * quantityTicket || 0} SR`
              : `SR ${ticketTypeSelect?.price * quantityTicket || 0}`}
          </p>
          <div className="absolute flex-row items-end w-full md:justify-between -bottom-10 md:w-auto md:static md:flex">
            <div className="w-full md:w-20">
              <BaseButton
                onClick={handleAddTicket}
                disable={!ticketTypeSelect}
                variant="filled"
                title={t("save")}
                className="px-3 py-2 font-bold text-body-2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
